// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import md5 from 'js-md5'
import jsCookie from 'js-cookie'
import '../static/css/font.css'

Vue.prototype.$cookie = jsCookie
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5
Vue.config.productionTip = false

//注册自动获取焦点事件
Vue.directive('autofocus', {
  inserted: function(el, binding) {
    el.focus();
  }
})

axios.interceptors.response.use(function (response) {
  if (response.data.code == 1000001 || response.data.code == 1000002) {
    window.location.replace('/dataroom/login')
  }
  return response
}, function (error) {
  if (error.response.status === 401) {
    window.location.replace('/dataroom/login')
  } else if (error.response.status === 404) {
    // window.location.replace('/error')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js